// Activity State Icons from the RFA Design System (Figma node 5768:4899): a 20px filled circle
// carrying a clock glyph, where the fill colour signals how much time is left.
const CLOCK_PATH =
  'M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 ' +
  '8.13401 5 12 5ZM12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 ' +
  '18 12C18 8.68629 15.3137 6 12 6ZM15 12C15.2761 12 15.5 12.2239 15.5 12.5C15.5 12.7761 15.2761 ' +
  '13 15 13H11.5V8.5C11.5 8.22386 11.7239 8 12 8C12.2761 8 12.5 8.22386 12.5 8.5V12H15Z';

export type ActivityStateIconVariant = 'countDown' | 'closingSoon';

const FILL: Record<ActivityStateIconVariant, string> = {
  countDown: '#F9AB01', // Foundation Palette/Yellow/Yellow-40
  closingSoon: '#DB0010', // system/negative-mid
};

interface ActivityStateIconProps {
  variant: ActivityStateIconVariant;
}

export function ActivityStateIcon({ variant }: ActivityStateIconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="2" y="2" width="20" height="20" rx="10" fill={FILL[variant]} />
      <path d={CLOCK_PATH} fill="#fff" />
    </svg>
  );
}
